module.exports = __webpack_public_path__ + "media/images/emblems/Buchholterberg-coat_of_arms-0e1cee2e9a3bb14bace45230f5041d5c.svg";